import React from 'react';
import CustomTabView from '../../../shared/TabView/CustomTabView';
import ReportsList from './ManageReports/ReportsList';
import RulesList from './ManageRules/RulesList';

export default function Reports() {
    const tabs = [{ title: 'Manage Reports', content: <ReportsList /> }];
    return <CustomTabView tabs={tabs} />;
}
